"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8278],{

/***/ 58278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _index_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3517);
/* harmony import */ var _icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52818);








/* eslint-disable arrow-body-style */ /**
 * Renders a button. Supports icons.
 */ var Button = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var children = _param.children, disabled = _param.disabled, disabledAlt = _param.disabledAlt, hasLabel = _param.hasLabel, _size = _param.size, size = _size === void 0 ? "regular" : _size, _leftIconHeight = _param.leftIconHeight, leftIconHeight = _leftIconHeight === void 0 ? size === "xsmall" ? 12 : 16 : _leftIconHeight, leftIconSrc = _param.leftIconSrc, _leftIconWidth = _param.leftIconWidth, leftIconWidth = _leftIconWidth === void 0 ? size === "xsmall" ? 12 : 16 : _leftIconWidth, onClick = _param.onClick, _rightIconHeight = _param.rightIconHeight, rightIconHeight = _rightIconHeight === void 0 ? size === "xsmall" ? 12 : 16 : _rightIconHeight, rightIconSrc = _param.rightIconSrc, _rightIconWidth = _param.rightIconWidth, rightIconWidth = _rightIconWidth === void 0 ? size === "xsmall" ? 12 : 16 : _rightIconWidth, _type = _param.type, type = _type === void 0 ? "submit" : _type, _variant = _param.variant, variant = _variant === void 0 ? "secondary" : _variant, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "disabled",
        "disabledAlt",
        "hasLabel",
        "size",
        "leftIconHeight",
        "leftIconSrc",
        "leftIconWidth",
        "onClick",
        "rightIconHeight",
        "rightIconSrc",
        "rightIconWidth",
        "type",
        "variant"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_index_styles__WEBPACK_IMPORTED_MODULE_2__/* .Wrapper */ .im, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, otherProps), {
        disabled: disabled,
        disabledAlt: disabledAlt,
        hasLabel: hasLabel !== null && hasLabel !== void 0 ? hasLabel : Boolean(children),
        onClick: onClick,
        ref: ref,
        size: size,
        type: type,
        variant: variant,
        children: [
            leftIconSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_styles__WEBPACK_IMPORTED_MODULE_2__/* .IconWrapper */ .a1, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    alt: "",
                    src: leftIconSrc,
                    width: leftIconWidth,
                    height: leftIconHeight,
                    inline: true
                })
            }),
            children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_styles__WEBPACK_IMPORTED_MODULE_2__/* .LabelWrapper */ .ub, {
                size: size,
                children: children
            }),
            rightIconSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_styles__WEBPACK_IMPORTED_MODULE_2__/* .IconWrapper */ .a1, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    alt: "",
                    src: rightIconSrc,
                    width: rightIconWidth,
                    height: rightIconHeight,
                    inline: true
                })
            })
        ]
    }));
});
Button.displayName = "Button";
Button.propTypes = {
    /**
   * Component that should render the button.
   */ as: prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func),
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object),
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string)
    ]),
    /**
   * Button label.
   */ children: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node),
    /**
   * Whether to disable the button.
   */ disabled: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    /**
   * Whether to use alternative styling for disabled button.
   */ disabledAlt: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    /**
   * Whether to render button with 100% width.
   */ fullWidth: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    /**
   * Whether the button has a (text-based) label. Usually determined by the presence of `children`.
   */ hasLabel: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    /**
   * Left icon height in pixels (recommended if icon URL is used).
   */ leftIconHeight: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number),
    /**
   * Left icon, left icon source or left icon URL.
   */ leftIconSrc: prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().element),
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node),
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object),
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string), 
    ]),
    /**
   * Left icon width in pixels (recommended if icon URL is used).
   */ leftIconWidth: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number),
    /**
   * Function to run on click.
   */ onClick: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func),
    /**
   * Right icon height in pixels (recommended if icon URL is used).
   */ rightIconHeight: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number),
    /**
   * Right icon, right icon source or right icon URL.
   */ rightIconSrc: prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().element),
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node),
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object),
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string), 
    ]),
    /**
   * Right icon width in pixels (recommended if icon URL is used).
   */ rightIconWidth: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number),
    /**
   * Button size.
   */ size: prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOf([
        "large",
        "regular",
        "small",
        "xsmall"
    ]),
    /**
   * Button title.
   */ title: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    /**
   * Button type.
   */ type: prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOf([
        "button",
        "reset",
        "submit"
    ]),
    /**
   * Button variant. "-round" variants are typically used for icon-only buttons.
   */ variant: prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOf([
        "primary",
        "primary-round",
        "destructive",
        "destructive-round",
        "secondary",
        "secondary-round",
        "tertiary",
        "tertiary-round", 
    ])
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 3517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Er": function() { return /* binding */ primaryButtonStyles; },
/* harmony export */   "M": function() { return /* binding */ secondaryButtonStyles; },
/* harmony export */   "a1": function() { return /* binding */ IconWrapper; },
/* harmony export */   "gb": function() { return /* binding */ tertiaryButtonStyles; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "ub": function() { return /* binding */ LabelWrapper; }
/* harmony export */ });
/* unused harmony exports buttonStyles, destructiveButtonStyles */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70714);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-grow: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 100%;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              border-radius: 14px;\n            "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              padding: 2px 8px;\n            "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            min-width: 28px;\n            min-height: 28px;\n            font-size: 14px;\n\n            ",
        "\n\n            ",
        "\n          "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              border-radius: 16px;\n            "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              padding: 4px 8px;\n            "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            min-width: 32px;\n            min-height: 32px;\n\n            ",
        "\n\n            ",
        "\n          "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              border-radius: 20px;\n            "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              padding: 8px 12px;\n            "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            min-width: 40px;\n            min-height: 40px;\n\n            ",
        "\n\n            ",
        "\n          "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              border-radius: 24px;\n            "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              padding: 12px 20px;\n            "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            min-width: 48px;\n            min-height: 48px;\n            gap: 12px;\n\n            ",
        "\n\n            ",
        "\n          "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            background: none;\n          "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            background-color: var(--coolGray-300);\n          "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              background: none;\n            "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              background-color: var(--coolGray-300);\n            "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 0;\n  background: none;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  color: white;\n  font: inherit;\n  font-weight: normal;\n  line-height: 1.2;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  outline: none;\n  transition: all 250ms ease;\n\n  ",
        "\n\n  &:hover, &:focus {\n    box-shadow: var(--shadow-base);\n    text-decoration: none;\n  }\n\n  &:focus-visible {\n    box-shadow: 0 0 0 2px var(--outlineColor);\n    text-decoration: none;\n  }\n\n  &:disabled {\n    ",
        "\n    box-shadow: none;\n    color: var(--coolGray-400);\n    cursor: not-allowed;\n\n    &:hover,\n    &:focus {\n      ",
        "\n      box-shadow: none;\n      color: var(--coolGray-400);\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  background-color: var(--primary-900);\n  font-weight: 600;\n\n  &:hover {\n    box-shadow: var(--shadow-lg);\n  }\n\n  &:hover,\n  &:focus {\n    background-color: var(--primary-1000);\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  background-color: var(--white);\n  box-shadow: var(--shadow-base);\n  color: var(--primary-900);\n\n  &:hover {\n    box-shadow: var(--shadow-lg);\n  }\n\n  &:hover,\n  &:focus {\n    background-color: var(--coolGray-100);\n  }\n\n  ",
        " {\n    color: var(--primary-400);\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  background-color: transparent;\n  color: var(--primary-900);\n\n  &:hover,\n  &:focus {\n    background-color: var(--indigo-50);\n  }\n\n  ",
        " {\n    color: var(--blue-400);\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  background-color: var(--pink-900);\n\n  &:hover,\n  &:focus {\n    background-color: var(--pink-1000);\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "}\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}

var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-20af29d4-0"
})(_templateObject());
var LabelWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-20af29d4-1"
})(_templateObject1());
var buttonStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject19(), function(props) {
    return props.fullWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject2());
}, function(props) {
    return function() {
        switch(props.size){
            case "xsmall":
                var ref;
                return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject5(), ((ref = props.variant) === null || ref === void 0 ? void 0 : ref.endsWith("-round")) && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject3()), props.hasLabel && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject4()));
            case "small":
                var ref1;
                return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject8(), ((ref1 = props.variant) === null || ref1 === void 0 ? void 0 : ref1.endsWith("-round")) && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject6()), props.hasLabel && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject7()));
            case "regular":
            default:
                var ref2;
                return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject11(), ((ref2 = props.variant) === null || ref2 === void 0 ? void 0 : ref2.endsWith("-round")) && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject9()), props.hasLabel && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject10()));
            case "large":
                var ref3;
                return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject14(), ((ref3 = props.variant) === null || ref3 === void 0 ? void 0 : ref3.endsWith("-round")) && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject12()), props.hasLabel && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject13()));
        }
    }();
}, function(props) {
    return props.disabledAlt ? (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject15()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject16());
}, function(props) {
    return props.disabledAlt ? (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject17()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject18());
});
var primaryButtonStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject20(), buttonStyles);
var secondaryButtonStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject21(), buttonStyles, IconWrapper);
var tertiaryButtonStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject22(), buttonStyles, IconWrapper);
var destructiveButtonStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject23(), buttonStyles);
var shouldForwardProp = function(prop) {
    return ![
        "disabledAlt",
        "fullWidth",
        "hasLabel"
    ].includes(prop);
};
var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("button").withConfig({
    shouldForwardProp: shouldForwardProp
}).withConfig({
    componentId: "sc-20af29d4-2"
})(_templateObject24(), function(props) {
    return function() {
        switch(props.variant){
            case "primary":
            case "primary-round":
                return primaryButtonStyles;
            case "secondary":
            case "secondary-round":
            default:
                return secondaryButtonStyles;
            case "tertiary":
            case "tertiary-round":
                return tertiaryButtonStyles;
            case "destructive":
            case "destructive-round":
                return destructiveButtonStyles;
        }
    }();
});


/***/ }),

/***/ 52818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Icon; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/nanoid/index.browser.js

let random = bytes => crypto.getRandomValues(new Uint8Array(bytes))
let customRandom = (alphabet, defaultSize, getRandom) => {
  let mask = (2 << (Math.log(alphabet.length - 1) / Math.LN2)) - 1
  let step = -~((1.6 * mask * defaultSize) / alphabet.length)
  return (size = defaultSize) => {
    let id = ''
    while (true) {
      let bytes = getRandom(step)
      let j = step
      while (j--) {
        id += alphabet[bytes[j] & mask] || ''
        if (id.length === size) return id
      }
    }
  }
}
let customAlphabet = (alphabet, size = 21) =>
  customRandom(alphabet, size, random)
let nanoid = (size = 21) =>
  crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte) => {
    byte &= 63
    if (byte < 36) {
      id += byte.toString(36)
    } else if (byte < 62) {
      id += (byte - 26).toString(36).toUpperCase()
    } else if (byte > 62) {
      id += '-'
    } else {
      id += '_'
    }
    return id
  }, '')


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(70714);
;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/icon/inline_svg.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: ",
        "px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: ",
        "px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: ",
        "px;\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        height: ",
        "px;\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  line-height: 0;\n  ",
        "\n  ",
        "\n\n  svg {\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Wrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e0b835cc-0"
})(_templateObject4(), function(props) {
    return props.width && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), props.width);
}, function(props) {
    return props.height && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), props.height);
}, function(props) {
    return props.width && (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), props.width);
}, function(props) {
    return props.height && (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), props.height);
});

;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/icon/inline_svg.jsx





var idRegExp = new RegExp('id="', "g");
var urlRegExp = new RegExp("url\\(#", "g");
var xlinkRegExp = new RegExp('xlink:href="#', "g");
/* eslint-disable react/no-danger */ function InlineSvg(param) {
    var _children = param.children, children = _children === void 0 ? "" : _children, height = param.height, width = param.width;
    var baseId = (0,react.useRef)(nanoid());
    var sanitizedContent = children.replace('<?xml version="1.0" encoding="UTF-8"?>', "").replace(idRegExp, 'id="'.concat(baseId.current, "__")).replace(urlRegExp, "url(#".concat(baseId.current, "__")).replace(xlinkRegExp, 'xlink:href="#'.concat(baseId.current, "__")).trim();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        width: width,
        height: height,
        dangerouslySetInnerHTML: {
            __html: sanitizedContent
        }
    });
};
InlineSvg.propTypes = {
    children: (prop_types_default()).string,
    height: (prop_types_default()).number,
    width: (prop_types_default()).number
};

;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/icon/external_svg.jsx




function ExternalSvg(param) {
    var src = param.src, width = param.width, height = param.height;
    var ref = (0,react.useState)(""), content = ref[0], setContent = ref[1];
    (0,react.useEffect)(function() {
        fetch(src).then(function(response) {
            return response.text();
        }).then(setContent).catch(function() {});
    }, [
        src
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineSvg, {
        width: width,
        height: height,
        children: content
    });
};
ExternalSvg.propTypes = {
    height: (prop_types_default()).number,
    src: (prop_types_default()).string,
    width: (prop_types_default()).number
};

;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/icon/index.jsx







/**
 * Renders an icon. Supports:
 *
 * * all image formats
 * * SVG passed as text
 * * React components
 * * React elements
 *
 * SVG icons can be inlined, which comes in handy when CSS styles must be applied or inherited in
 * them.
 */ function Icon(param) {
    var alt = param.alt, height = param.height, _inline = param.inline, inline = _inline === void 0 ? false : _inline, src = param.src, width = param.width;
    if (!src) {
        return null;
    }
    if (typeof src !== "string") {
        if (typeof src === "object") {
            if (/*#__PURE__*/ react.isValidElement(src)) {
                return /*#__PURE__*/ react.cloneElement(src, {
                    alt: alt,
                    height: height,
                    width: width
                });
            }
            return /*#__PURE__*/ react.createElement(src, {
                alt: alt,
                height: height,
                width: width
            });
        }
        return src;
    }
    var props = {
        width: width,
        height: height
    };
    if (inline) {
        if (src.endsWith("svg")) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                src: src
            }));
        }
        if (src.includes("<svg")) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineSvg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                children: src
            }));
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        alt: alt,
        src: src
    }));
};
Icon.propTypes = {
    /**
   * Alternative text. Pass `""` for decorative elements.
   */ alt: (prop_types_default()).string.isRequired,
    /**
   * Height in pixels (recommended if icon URL is used).
   */ height: (prop_types_default()).number,
    /**
   * Whether to inline the icon. Only applicable to SVG icons. This comes in handy when CSS styles
   * must be applied or inherited in SVG icon.
   */ inline: (prop_types_default()).bool,
    /**
   * Icon, icon source or icon URL.
   */ src: prop_types_default().oneOfType([
        (prop_types_default()).element,
        (prop_types_default()).node,
        (prop_types_default()).object,
        (prop_types_default()).string
    ]).isRequired,
    /**
   * Width in pixels (recommended if icon URL is used).
   */ width: (prop_types_default()).number
};


/***/ })

}]);